import { render, staticRenderFns } from "./CreateRole.vue?vue&type=template&id=3eebe93d&scoped=true&"
import script from "./CreateRole.vue?vue&type=script&lang=ts&"
export * from "./CreateRole.vue?vue&type=script&lang=ts&"
import style0 from "./CreateRole.vue?vue&type=style&index=0&id=3eebe93d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eebe93d",
  null
  
)

export default component.exports